import { authHeader } from "../_helpers";
import Joi from "joi";

const globalHeaders = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Credentials": true,

};

let serverUrl = "https://api.mybenefitz.com";
if (process.env.REACT_APP_ENV_TYPE === "test") {
  serverUrl = "https://api-test.mybenefitz.com";
} else if (process.env.REACT_APP_ENV_TYPE === "development") {
  serverUrl = "http://localhost:8090";
} else if (process.env.REACT_APP_ENV_TYPE === "prod") {
  serverUrl = "https://api.mybenefitz.com";
}
console.log("API Path", serverUrl);

async function allBusinessBenefitOffer() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(
    `${serverUrl}/admin/business/${user.business_id}/benefit_offer`,
    requestOptions
  )
    .then((res) => res.json())
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

// function approveRequestByID(reqID, points) {
//   let data = {
//     "requestId": reqID,
//     "pointsToReduce": points,
//   }
//   const requestOptions = {
//       method: 'POST',
//       headers: {...authHeader(), ...globalHeaders},
//       body: JSON.stringify(data),
//   };
//   let user = JSON.parse(localStorage.getItem('user'));
//   return fetch(`${serverUrl}/admin/club`, requestOptions)
//   .then(response => response.json())
//   .then(user => {
//       resolve(JSON.stringify(user));
//   }).catch((err)=>{
//     console.log(err)
//   })
// }

export const addBenefitToUserByCode = async ({ benefitOfferId, pointsStatus, code }) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify({ benefitOfferId, pointsStatus, code }),
  };

  let user = localStorage.getItem("user");
  user = JSON.parse(user);

  return fetch(
    `${serverUrl}/business/${user.business_id}/used_benefit`,
    requestOptions
  )
    .then((response) => response.json())
    .then((user) => {
      return JSON.stringify(user);
    })
    .catch(handleError);
};

export const addBenefit = async  ({ clubId, benefit}) => {
    const requestOptions = {
      method: "POST",
      headers: { ...authHeader(), ...globalHeaders },
      body: JSON.stringify(benefit),
    };

    let user = localStorage.getItem("user");
    user = JSON.parse(user);

    return fetch(
        `${serverUrl}/admin/club/${clubId}/benefit_offer`,
         requestOptions)
        .then((response) => response.json())
        .then((user) => {
          return JSON.stringify(user);
        })
        .catch(handleError);
};

export function getClubDetails(clubId) {
  // https://api.mybenefitz.com:443/admin/club/63ee2fc77437af000724f51c
  //https://api.mybenefitz.com:443/admin/club/63ee2fc77437af000724f51c/benefit_offer
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(),...globalHeaders },
  };

  return fetch(`${serverUrl}/admin/club/${clubId}`, requestOptions)
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
}

const updatedDataSchema = Joi.object({
  price: Joi.number().greater(0).required(),
  points: Joi.number().greater(0).required(),
  discountAmount: Joi.number().greater(0).required(),
  description: Joi.string().min(2).required(),
  longDescription: Joi.string().min(2).required(),
});

//editing a existing benefit in DB
export const updateBenefit = async (clubId, benefitId, updatedData) => {

  try {
    // export all -abortEarly:false- error that comes from Joi Validation
    const { error } = updatedDataSchema.validate(updatedData, { abortEarly: false });
    if (error) {
      console.error("Validation failed:", error.details.map((d) => d.message).join(", "));
      throw new Error(`Invalid data: ${error.details.map((d) => d.message).join(", ")}`);
    }

    const requestOptions = {
      method: "POST",
      cache: 'no-cache',
      headers: { ...authHeader(), ...globalHeaders },
      body: JSON.stringify(updatedData),
    }
    return fetch(`${serverUrl}/admin/club/${clubId}/benefit_offer/${benefitId}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
  } catch (error) {
    console.log(error.message)
    return (error);
  }
}

function getAllClubsOfBusiness() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(),...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  let businessId = user?.business_id
  return fetch(`${serverUrl}/business/${businessId}/clubs`, requestOptions)
      .then(async (response) => {
        const text = await response.text();  // קבל את התגובה כטקסט
        console.log("Raw server response:", text);  // כדי להבין מה לא תקין
        try {
          return JSON.parse(text); // נסה לפענח ידנית
        } catch (err) {
          console.error("Error parsing JSON response:", err);
          throw err;
        }
      });
    // .then((response) => response.json())
    // .then((response) => {
    //   return response;
    // });
}

export const getClubOffer = async (clubId) => {
  // https://api.mybenefitz.com:443/admin/club/63ee2fc77437af000724f51c
  //https://api.mybenefitz.com:443/admin/club/63ee2fc77437af000724f51c/benefit_offer
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(),...globalHeaders },
  };

  return fetch(
    `${serverUrl}/admin/club/${clubId}/benefit_offer`,
    requestOptions
  )
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
}

export const getClubBusinessMemberOffers = async (clubBusinessMemberId) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(),...globalHeaders }
  };
  return fetch(
      `${serverUrl}/admin/clubBusinessMember/${clubBusinessMemberId}/benefit_offer`,
      requestOptions
  )
      .then((response) => response.json())
      .then((response) => {
        return response;
      });
}

// Create club // POSTMAN
export const createClub = async ({
  name,
  description,
  phoneNum,
  email,
  website,
  extraInfo,
  type,
  smallLogoUrl,
  largeLogoUrl,
}) => {
  const requestOptions = {
    method: "POST",
    cache: "no-cache",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify({
      name,
      description,
      phoneNum,
      email,
      website,
      extraInfo,
      type,
      smallLogoUrl,
      largeLogoUrl,
    }),
  };

  return fetch(`${serverUrl}/admin/club`, requestOptions)
    .then((response) => response.json())
    .then((user) => {
      return JSON.stringify(user);
    })
    .catch((err) => {
      console.log(err);
      alert(err);
    });
};

// add benefit to club
export const clubOffer = ({
  price,
  points,
  possiblePurchases,
  discountAmount,
  smallPicturlUrl,
  largePicturlUrl,
  type,
  description,
  longDescription,
  clubId
}) => {
  const requestOptions = {
    method: "POST",
    cache: "no-cache",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify({
      price,
      points,
      possiblePurchases,
      discountAmount,
      smallPicturlUrl,
      largePicturlUrl,
      type,
      description,
      longDescription,
      clubId
    }),
  };

  //const clubId = JSON.parse(localStorage.getItem("clubId"));

  return new Promise((resolve) => {
    fetch(`${serverUrl}/admin/club/${clubId}/benefit_offer`, requestOptions)
      .then(handleResponse)
      .then((benefit) => {
        resolve(JSON.stringify(benefit));
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  });
};

// create business (TODO: chenge fuction name)
export const brandInfo = (data) => {
  // Encode the password before sending
  const encodedData = {
    ...data,
    password: encodeURIComponent(data.password)
  };

  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify(encodedData),
  };
  return new Promise((resolve, reject) => {
    fetch(`${serverUrl}/admin/business`, requestOptions)
      .then(handleResponse)
      .then((res) => {
        resolve(JSON.stringify(res));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//add business to club
export const addbusinessToClub = ({ id }) => {
  const requestOptions = {
    method: "POST",
    cache: "no-cache",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify({ id }),
  };

  const clubId = JSON.parse(localStorage.getItem("clubId"));

  return new Promise((resolve, reject) => {
    fetch(`${serverUrl}/admin/club/${clubId.id}/business`, requestOptions)
      .then(handleResponse)
      .then((brand) => {
        resolve(JSON.stringify(brand));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// create Brand //POSTMAN
export const addBrand = async ({ name, description, logoUrl }) => {
  const requestOptions = {
    method: "POST",
    cache: "no-cache",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify({ name, description, logoUrl }),
  };

  return fetch(`${serverUrl}/admin/brand`, requestOptions)
    .then((res) => res.json())
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export function login(email, password) {
  const requestOptions = {
    method: "POST",
    cache: "no-cache",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify({
      email,
      password: encodeURIComponent(password)
    }),
  };

  return fetch(`${serverUrl}/business/login`, requestOptions)
    .then((response) => response.json())
    .then((user) => {
      // login successful if there's a user in the response
      if (user.access_token) {
        // store user details and basic auth credentials in local storage
        // to keep user logged in between page refreshes
        user.authdata = window.btoa(encodeURIComponent(email + ":" + password));
        localStorage.setItem("user", JSON.stringify(user));
      }
      return user;
    })
    .catch((err)=> {
      return err;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
}

async function getInfo() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(`${serverUrl}/business/${user.business_id}`, requestOptions)
    .then((res) => res.json())
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

async function updatePushToken() {
  let data = {
    pushNotificationToken: localStorage.getItem("pushNotificationToken"),
  };
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify(data),
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(
    `${serverUrl}/business/${user.business_id}/updateDeviceToken`,
    requestOptions
  )
    .then((res) => res.json())
    .then((res) => {
      return res;
    })
    .catch((err) => console.log(err));
}

function checkInfoAvailable() {
  getInfo()
    .then((x) => {
      console.log(x);
      return true;
    })
    .catch((x) => {
      console.log("fail", x);
      return false;
    });
}

function getRequestByCode(code) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(
    `${serverUrl}/business/${user.business_id}/request/${code}`,
    requestOptions
  )
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
}

async function approveRequestByID(reqID, points) {
  let data = {
    requestId: reqID,
    pointsToReduce: points,
  };
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify(data),
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(
    `${serverUrl}/business/${user.business_id}/request/redeem`,
    requestOptions
  )
    .then((res) => res.json())
    .then((res) => {
      return res;
    })
    .catch((err) => console.log(err));
}

function getHistory(dateRange) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  let url =
    `${serverUrl}/business/${user.business_id}/benefit/history` +
    `?prevDays=${dateRange.prevDays ? dateRange.prevDays : ""}` +
    `&fromDate=${dateRange.fromDate ? dateRange.fromDate : ""}` +
    `&toDate=${dateRange.toDate ? dateRange.toDate : ""}`;

  return fetch(url, requestOptions)
    .then((response) => response.json())
    .then((res) => {
      var array = [];
      res.purchesed.forEach((purchase) => {
        purchase.objectType = "purchased";
        array.push(purchase);
      });
      res.usage.forEach((usage) => {
        usage.objectType = "usage";
        array.push(usage);
      });
      res.canceled.forEach((canceled) => {
        canceled.objectType = "canceled";
        array.push(canceled);
      });
      array.sort((a, b) => {
        if (a.createDate > b.createDate) return -1;
        if (a.createDate < b.createDate) return 1;
        return 0;
      });

      return array;
    });
}

function getRequsts() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(
    `${serverUrl}/business/${user.business_id}/request`,
    requestOptions
  )
    .then((res) => res.json())
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}
function getBenefitPurchased() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(
    `${serverUrl}/business/${user.business_id}/benefit_purchased`,
    requestOptions
  )
    .then(handleResponse)
    .catch(handleError);
}
function getBenefitUsage() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  return fetch(
    `${serverUrl}/business/${user.business_id}/benefit_usage`,
    requestOptions
  )
    .then(handleResponse)
    .catch(handleError);
}
function undoTransaction(type, id) {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(), ...globalHeaders },
  };
  let user = JSON.parse(localStorage.getItem("user"));
  switch (type) {
    case "purchased":
      return fetch(
        `${serverUrl}/business/${user.business_id}/benefit_purchased/${id}/refund`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          return response;
        });
    case "usage":
      return fetch(
        `${serverUrl}/business/${user.business_id}/benefit_usage/${id}/refund`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          return response;
        });
    default:
      return Promise.reject("Unknown type: " + type);
  }
}

function handleResponse(response) {
  // prevent throwing JSON parse errors when backend returns HTML (500 pages)
  console.log("response:", response);

  return response.text().then((text) => {
    const contentType = (response.headers && response.headers.get && response.headers.get("content-type")) || "";
    let data = null;

    if (contentType.includes("application/json")) {
      try {
        data = text ? JSON.parse(text) : null;
      } catch (parseErr) {
        console.error("JSON parse error for response body:", parseErr, text);
      }
    } else {
      // Non-JSON (likely HTML error page) — keep raw text for debugging
      console.warn("Non-JSON response body (status " + response.status + "):", text);
    }

    if (!response.ok) {
      const errorPayload = {
        status: response.status,
        statusText: response.statusText,
        body: text,
        json: data,
      };
      return Promise.reject(errorPayload);
    }

    return data;
  });
}


function postAddBenefitToUser(benefitOfferId, pointsStatus, code) {
  let data = {
    benefitOfferId: benefitOfferId,
    pointsStatus: pointsStatus,
    code: code,
  };
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), ...globalHeaders },
    body: JSON.stringify(data),
  };
  let user = JSON.parse(localStorage.getItem("user"));
  console.log(user.business_id);
  return fetch(
    `${serverUrl}/business/${user.business_id}/used_benefit`,
    requestOptions
  )
    .then((response) => response.json())
    .then((response) => {
      return response;
    });
}

function handleError(e) {
  console.log("Error:", e);
  // logout();
  // window.location.reload(true);
  return Promise.reject(e);
}

export const userService = {
  logout, // done
  getInfo,
  checkInfoAvailable,
  getRequsts,
  getRequestByCode, // done
  updatePushToken,
  approveRequestByID, // done
  getBenefitPurchased, // Not used
  getBenefitUsage, // Not used
  getHistory, // done
  undoTransaction, // done
  allBusinessBenefitOffer,
  postAddBenefitToUser,
  createClub,
  addBenefit,
  clubOffer,
  brandInfo,
  getClubDetails,
  getAllClubsOfBusiness,
  getClubOffer,
  getClubBusinessMemberOffers,
  addBrand,
};
